export const MAX_END_SESSION_TIME = '15:00:00'
export const MAX_END_SESSION_TIME_WITH_PROLONGATION = '15:00:00'
export const MIN_START_SESSION_TIME = '11:00:00'
export const MAX_START_SESSION_TIME = '14:00:00'
export const MAX_FILES_COUNT_PER_REQUEST = 10
export const MIN_WARRANRY_PERCENT = 0.05
export const MAIN_ADMIN_NAME = 'ADMINISTRATOR'
export const ADMIN_INN = '7840389730'
export const VAT_TEXT = 'без учета НДС, в валюте Контракта'
export const RUSSIAN_COUNTRY_ID = 180
export const MAX_PREMIUM_STEP_COUNT = 20
export const WARNING_PREMIUM_STEP_COUNT = 5
export const MAX_FIX_PREMIUM_VALUE = 99999999999.99
export const MIN_FIX_PREMIUM_VALUE = 0.01
export const MAX_DIFF_PREMIUM_VALUE = 999.99
export const MIN_DIFF_PREMIUM_VALUE = -999.99

export const LOT_TYPES = Object.freeze({
  TWO_STAGED_OFFERS: 'twoStagedOffers',
  PRIVATE_REQUEST_OFFERS: 'privateRequestOffers',
  PUBLIC_REQUEST_OFFERS: 'publicRequestOffers'
})

export const THEME_TYPES = Object.freeze({
  LIGHT: 'light',
  DARK: 'dark'
})

export const SESSION_TYPES = Object.freeze({
  PRIVATE_OFFERS: 'privateOffers',
  PUBLIC_OFFERS: 'publicOffers',
  PRIVATE_TWO_STAGED_OFFERS: 'privateTwoStagedOffers',
  PUBLIC_TWO_STAGED_OFFERS: 'publicTwoStagedOffers',
  TWO_STAGED: 'twoStaged'
})

export const STATIC_FILE_TYPES = Object.freeze({
  PICTURE: 'picture',
  DOC: 'doc'
})

export const PARTICIPANT_TYPES = Object.freeze({
  SUPER_ORGANIZER: 'superorganizer',
  ORGANIZER: 'organizer',
  PARTICIPANT: 'participant'
})

export const PREMIUM_TYPES = Object.freeze({
  DIFFERENTIAL: 'differential',
  FIX: 'fix'
})

export const AUTHORIZATION_DOCUMENT_TYPES = Object.freeze({
  USER_AUTHORIZATION_DOCUMENT: 'userAuthorizationDocument'
})

export const USER_TYPES = Object.freeze({
  UNREGISTERED: 'unregistered',
  REGISTERED: 'registered'
})

export const LOT_STATUSES = Object.freeze({
  REGISTERED: 'registered',
  DRAFT: 'draft',
  FINISHED: 'finished',
  RECALLED: 'recalled'
})

export const SUBSCRIPTION_TYPES = Object.freeze({
  FULL: 'full',
  PARTIAL: 'partial',
  NONE: 'none'
})

export const DOCUMENT_STATUSES = Object.freeze({
  INPROCESS: 'inprocess',
  APPROVED: 'approved',
  DISABLED: 'disabled'
})

export const REQUEST_STATUSES = Object.freeze({
  CREATED: 'created',
  INPROCESS: 'inprocess',
  REJECTED: 'rejected',
  APPROVED: 'approved'
})

export const ORG_REQUEST_STATUSES = Object.freeze({
  CREATED: 'created',
  INPROCESS: 'inprocess',
  REJECTED: 'rejected',
  APPROVED: 'approved'
})

export const LOT_REQUEST_STATUSES = Object.freeze({
  CREATED: 'created',
  INPROCESS: 'inprocess',
  REJECTED: 'rejected',
  APPROVED: 'approved'
})

export const ORGANIZATION_TABS = Object.freeze({
  GENERAL_INFO: 'generalInfo',
  USERS: 'users',
  DOCUMENTS: 'documents'
})

export const IDENTITY_REQUEST_TYPES = Object.freeze({
  LEGAL_ORGANIZATION: 'legalOrganization',
  PARTICIPANT_LEGAL_ORGANIZATION: 'participantlegalOrganization',
  ORGANIZATION_AGENT: 'organizationAgent'
})

export const IDENTITY_DOCUMENT_GROUPS = Object.freeze({
  LEGAL_ORGANIZATION_DOCUMENTS: 'legalOrganizationDocuments',
  PARTICIPANT_LEGAL_ORGANIZATION_DOCUMENTS: 'participantLegalOrganizationDocuments',
  ORGANIZATION_AGENT_DOCUMENTS: 'organizationAgentDocuments'
})

export const BUSINESS_DOCUMENT_GROUPS = Object.freeze({
  OFFER_ADDITIONAL_INFO: 'offerAdditionalInfo',
  CLARIFICATION: 'clarification'
})

export const USER_TABS = Object.freeze({
  USER_INFO: 'userInfo',
  AUTHORIZATION_DOCUMENTS: 'authorizationDocuments',
  SUBSCRIPTIONS: 'subscriptions'
})

export const DOCUMENT_PERSON_IDENTITY_TYPES = Object.freeze({
  PASSPORT: 'passport',
  BIRTH_CERTIFICATE: 'birthCertificate',
  INTERNATIONAL_PASSPORT: 'internationalPassport',
  MILITARY_ID: 'militaryId',
  RUSSIAN_TEMPORARY_IDENTITY_CARD: 'russianTemporaryIdentityCard',
  SAILOR_ID: 'sailorId',
  RESIDENCE_PERMIT: 'residencePermit'
})

export const PRIVACY_TYPES = Object.freeze({
  PERSONAL: 'personal',
  ALL: 'all'
})

export const DICTIONARY_TYPES = Object.freeze({
  COUNTRIES: 'countries',
  PRODUCT_SECTIONS: 'productSections',
  INCOTERMS: 'incoterms',
  DELIVERY_BASISES: 'deliveryBasises'
})

export const LOT_TABS = Object.freeze({
  GENERAL_INFO: 'generalInfo',
  LOT_DOCUMENTS: 'lotDocuments',
  TRADE_PROCESS_DOCUMENTATION: 'tradeProcessDocumentation',
  TRADE_PROCESS: 'tradeProcess',
  ORDERS: 'orders',
  TRADE_RESULTS: 'tradeResults',
  LOT_REQUESTS: 'lotRequests',
  REGISTERS: 'registers'
})

export const DOCUMENT_TYPES = Object.freeze({
  REGISTRY: 'registry',
  CONTRACT: 'contract',
  CLARIFICATION: 'clarification',
  OFFER_ADDITIONAL_INFO: 'offerAdditionalInfo',
  NOTES: 'notes',
  NOTICE: 'notice',
  DOCUMENTATION: 'documentation',
  OFFERER_NOTIFICATION: 'offererNotification',
  STATEMENT: 'statement',
  USER_AUTHORIZATION_DOCUMENT: 'userAuthorizationDocument',
  ORGANIZATION_DOCUMENT: 'organizationDocument'
})

export const TRADE_DIRECTION_TYPES = Object.freeze({
  RAISING: 'raising',
  LOWERING: 'lowering'
})

export const LOT_REQUEST_TYPES = Object.freeze({
  REGISTRATION: 'registration',
  RECALL: 'recall',
  CHANGE_DOCUMENTS: 'changeDocuments',
  CONTRACT_CONDITION_FAIL: 'contractConditionFail'
})

export const LOT_ACTIONS = Object.freeze({
  ...LOT_REQUEST_TYPES,
  ADD_ORDERS: 'addOrders',
  DELETE: 'delete',
  TRADE_PROCESS_DOCUMENTATION: 'tradeProcessDocumentation',
  WINNER_SELECT: 'winnerSelect',
  CREATE_TEMPLATE: 'createTemplate'
})

export const TRADE_RESULT_TYPES = Object.freeze({
  UNSET: 'unset',
  FAILED: 'failed',
  WINNER_SELECTED: 'winnerSelected'
  // CONTRACT_FULFILLED: 'contractFulfilled'
})

export const SESSION_STATUSES = Object.freeze({
  UNLOCKED: 'unlocked',
  LOCKED_BY_PARTICIPANT_COUNT: 'lockedByParticipantCount',
  LOCKED_BY_LIMIT_PREMIUM: 'lockedByLimitPremium'
})

export const STATIC_PAGES_TAGS = Object.freeze({
  STATIC_DOCS_TARIFFS: 'static_docs_tariffs',
  STATIC_DOCS_ORG_REGISTRATION: 'static_docs_org_registration',
  STATIC_DOCS_USER_REGISTRATION: 'static_docs_user_registration',
  STATIC_DOCS_GUIDES: 'static_docs_guides',
  STATIC_DOCS_REQUISITES: 'static_docs_requisites',
  STATIC_MAIN_ADMIN: 'static_main_admin',
  STATIC_MAIN: 'static_main',
  STATIC_DIGITAL_SIGNATURE: 'static_digital_signature',
  STATIC_SKZI: 'static_skzi',
  STATIC_SUPPORT: 'static_support'
})

export const TIMER_STATUSES = Object.freeze({
  EXPIRED: 'expired',
  RUNNING: 'running',
  UPCOMING: 'upcoming'
})

export const TIME_UNITS = Object.freeze({
  DAYS: 'days',
  MINUTES: 'minutes',
  HOURS: 'hours',
  SECONDS: 'seconds',
  MILLISECONDS: 'milliseconds'
})

export const CAPTCHA_METHODS = Object.freeze({
  GOOGLE: 'google',
  CAPTCHA_GEN: 'captchaGen'
})
